import React, { useEffect, useState } from 'react';
import { Course, UserRole } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';

interface AnnouncementSectionProps {
  course: Course;
  userRole: UserRole;
  selectedModule: string;
}

const AnnouncementSection: React.FC<AnnouncementSectionProps> = ({ course, userRole, selectedModule }) => {
  const [announcements, setAnnouncements] = useState<any[]>([])
  useEffect(() => {
   
    const loadData = async() => {
       const instance = await getAxiosTokenInstance()
     try{
      const resp = await instance.get(`/college/lms/announcements/getAnnouncement?subjectId=subject123&collegeId=COLL-123`);
      if (resp?.data) {
        // Check if selectedModule is not 'all'
        console.log(selectedModule)
        if (selectedModule !== 'all') {
          const filteredContent = resp.data.data.filter((content: any) => {
            // Make sure to return true or false based on the condition
            return content.moduleId == selectedModule;
          });
          setAnnouncements(filteredContent); // Set the filtered content
        } else {
          setAnnouncements(resp.data.data); // If selectedModule is 'all', show all content
        }
      }

     }catch(err){
      
     }
    }
    loadData()

  },[userRole, course, selectedModule])
  //   {
  //     id: 1,
  //     title: 'Welcome to Advanced Mathematics',
  //     content: 'Welcome everyone! This semester we will cover advanced mathematical concepts. Please ensure you have the required textbook.',
  //     moduleId: 'all',
  //     date: '5/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'high'
  //   },
  //   {
  //     id: 2,
  //     title: 'Module 1 Resources Available',
  //     content: 'All resources for Introduction to Algebra are now available in the Materials section.',
  //     moduleId: 'mod1',
  //     date: '8/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'medium'
  //   },
  //   {
  //     id: 3,
  //     title: 'Office Hours This Week',
  //     content: 'Office hours will be extended this week. Tuesday and Thursday 2-4 PM in Room 205.',
  //     moduleId: 'all',
  //     date: '12/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'medium'
  //   },
  //   {
  //     id: 4,
  //     title: 'Linear Equations Assignment Extension',
  //     content: 'Due to technical issues, the Linear Equations assignment deadline has been extended by 2 days.',
  //     moduleId: 'mod2',
  //     date: '14/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'high'
  //   }
  // ]);
  
  useEffect(() => {
   
    const loadData = async() => {
       const instance = await getAxiosTokenInstance()
     try{
      const resp = await instance.get(`/college/lms/announcements/getAnnouncement?subjectId=subject123&collegeId=COLL-123`);
      if(resp?.data){
        setAnnouncements(resp.data.data)
      }

     }catch(err){
      
     }
    }
    loadData()

  },[userRole, course])
  //   {
  //     id: 1,
  //     title: 'Welcome to Advanced Mathematics',
  //     content: 'Welcome everyone! This semester we will cover advanced mathematical concepts. Please ensure you have the required textbook.',
  //     moduleId: 'all',
  //     date: '5/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'high'
  //   },
  //   {
  //     id: 2,
  //     title: 'Module 1 Resources Available',
  //     content: 'All resources for Introduction to Algebra are now available in the Materials section.',
  //     moduleId: 'mod1',
  //     date: '8/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'medium'
  //   },
  //   {
  //     id: 3,
  //     title: 'Office Hours This Week',
  //     content: 'Office hours will be extended this week. Tuesday and Thursday 2-4 PM in Room 205.',
  //     moduleId: 'all',
  //     date: '12/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'medium'
  //   },
  //   {
  //     id: 4,
  //     title: 'Linear Equations Assignment Extension',
  //     content: 'Due to technical issues, the Linear Equations assignment deadline has been extended by 2 days.',
  //     moduleId: 'mod2',
  //     date: '14/1/2024',
  //     author: 'Dr. Sarah Johnson',
  //     priority: 'high'
  //   }
  // ]);

  // // Filter announcements based on selected module
  // const filteredAnnouncements = announcements.filter(announcement => 
  //   selectedModule === 'all' || announcement.moduleId === selectedModule || announcement.moduleId === 'all'
  // );
  // // Filter announcements based on selected module
  // const filteredAnnouncements = announcements.filter(announcement => 
  //   selectedModule === 'all' || announcement.moduleId === selectedModule || announcement.moduleId === 'all'
  // );

  const getPriorityBadge = (priority: string) => {
    const baseClasses = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
    
    switch (priority) {
      case 'high':
        return `${baseClasses} bg-red-100 text-red-800`;
      case 'medium':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'low':
        return `${baseClasses} bg-green-100 text-green-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <h2 className="text-xl font-semibold">Announcements</h2>
      </div>

      <div className="space-y-4">
        {announcements?.map((announcement) => (
          <div
            key={announcement._id}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <span className="text-2xl">📢</span>
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                  {announcement.title}
                </h3>
              </div>
              <span className={getPriorityBadge(announcement.priority)}>
                {announcement.priority} priority
              </span>
            </div>

            <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
              {announcement.message}
            </p>

            <div className="flex justify-between items-center text-sm text-gray-500">
              <span>By {announcement.createdBy}</span>
              <span>{announcement.date}</span>
            </div>
          </div>
        ))}
      </div>

      {announcements.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">📢</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No announcements found
          </h3>
          <p className="text-gray-500">
            No announcements available for the selected module.
          </p>
        </div>
      )}
    </div>
  );
};

export default AnnouncementSection;
